import React, { useContext, useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { getCustomerResourceNames } from '../../services/api/GoogleApi';
import { AlertContext, Alert_, CardsSixty, Google_Search, Grey_Link, On_Click_Card, PageAlwaysVisible, PageDesktopOnly, PageIllu, PageSixty, PageSubtitle, PageTitle, Section_Search, Sixty_Card_Loader } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import i18n from '../../../../localization/i18next';
import { t } from 'i18next';

import dummyData from '../../data/dummyData.json';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import { AuthContext } from '../../../../services/authentication/Guard';

const environment = process.env.REACT_APP_SERVER;



const SOURCE_ACCOUNT = () => {

    const googleSourceStorage = store.getState().googleSource;
    const lang = i18n.language ? i18n.language : 'en';
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* LocalStorage Data */
    const GoogleSourceData = store.getState().googleSource;
    const googleUserProfile = GoogleSourceData?.userProfile;
    const managerAccount = GoogleSourceData?.managerAccount;
    const accessToken = googleUserProfile?.accessToken;

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    /* Search */ 
    const [searchResults, setSearchResults] = useState([]);
    const [displayedResults, setDisplayedResults] = useState([]);

    /* Alerts */
    const { alerts, setAlerts } = useContext(AlertContext);

    /* Check if user has source accounts */
    const [userHasData, setUserHasData] = useState(true);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };

    const [customerResourceName, setCustomerResourceNames] = useState([]);


    /* Fetch either real or dummy data */
    const initActions = () => {
        const get_Customer_Resource_Names = () => {
            getCustomerResourceNames(accessToken)
                .then((response) => {
                    const resourceNames = response?.data?.data?.customerResourceNames;
                    if ( resourceNames && resourceNames?.length > 0 ) {
                        setCustomerResourceNames(resourceNames);
                        setDisplayedResults(resourceNames);
                    } else {
                        setUserHasData(false); 
                    }
                })
                .catch(error=>{
                    console.error(error); 
                    setUserHasData(false);
                    alertMessage((t("Session expired")),'Error');
                    navigate(`/${lang}/google/connect`);
                })
        }
    

        if ( environment !== 'LOCAL' ) get_Customer_Resource_Names()
        else {
            setCustomerResourceNames(dummyData.getCustomerResourceNames.customerResourceNames)
            setDisplayedResults(dummyData.getCustomerResourceNames.customerResourceNames)
        }
    }


    const handleNavigation = (customer) => {
        store.dispatch({type: "SAVE_GOOGLE_MANAGER_ACCOUNT", payload: {
            ...managerAccount,
            resourceName: customer.resourceName,
            id: customer?.resourceName?.split('/')[1],
            name: customer.descriptiveName,
        }});
        navigate(`/${lang}/google/clients`);
    }

    useEffect(() => {
        if ( searchResults.input ) setDisplayedResults(searchResults.data);
        else setDisplayedResults(customerResourceName);
    },[searchResults])


    useEffect(() => {
        initActions()
    },[])


    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);


  return (
        <>
        <Helmet>
            <title>Adsnap | Google Accounts</title>
        </Helmet>
            <Alert_ messages={alerts} />
            { hasCheckOwnership && <PageSixty>
                <PageAlwaysVisible>
                    <PageTitle>
                        <Grey_Link iconLeft="Back" id={"AdSnap_Google_Select_Account_1"} onClick={() => navigate(`/${lang}/google/connect`)} noPadding />
                        <h1>{t('Select Google Ads Account')}</h1>
                    </PageTitle>
                    <PageSubtitle>
                            <p>{t('Choose the Google Manager Account that corresponds to the account you want to generate automated reports for. This step ensures that you have the correct permissions and access to the relevant data.')}</p>
                    </PageSubtitle>

                    {/* Google Search */}
                    {customerResourceName?.length >= 10 ? (
                            <Section_Search title={t('Search for a google ads account')}>
                                <Google_Search
                                    file={customerResourceName}
                                    fileKeys={['descriptiveName', 'id', 'descriptiveName_reversed']}
                                    defaultValue={''}
                                    sanitize={true}
                                    placeholder={t('Google ads account')}
                                    applyReverseFileProperties={[
                                        {
                                            originalKey: 'descriptiveName',
                                            reversedKey: 'descriptiveName_reversed',
                                        },
                                    ]}
                                    setResults={(data) => setSearchResults(data)}
                                    debounceTime={750}
                                    minMatchCharacters={1}
                                    maxMatchCharacters={50}
                                    disabled={false}
                                    isCaseSensitive={false}
                                    maxAcceptedScore={0.6}
                                />
                            </Section_Search>
                        ) : null}

                    { customerResourceName.length > 0 ? <CardsSixty>
                        {displayedResults.map((customer) => {
                            return <On_Click_Card 
                                        onClick={() => handleNavigation(customer)} 
                                        title={customer.descriptiveName}
                                        subtitle={`${customer?.id}`}    
                                        id={"AdSnap_Google_Select_Account_2"}
                                    />
                        })}
                    </CardsSixty> : userHasData ? <Sixty_Card_Loader/> : 'No data found' } 
                </PageAlwaysVisible>
                <PageDesktopOnly>
                        <PageIllu>
                            <img src="https://genius1071.friktoriaservers.net/doitforme/morning/app/lois/HeaderAvatar.svg" />
                        </PageIllu>
                </PageDesktopOnly>
            </PageSixty> }
        </>
  );
};

export default SOURCE_ACCOUNT;
